import React, { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-family: Verdana, sans-serif;
  color: var(--secondary-font-color);
  cursor: pointer;
`;

export interface Props {
  name: string;
  setSelectedValue: (selectedValue: string) => void;
  options: {
    value: string;
    label: string;
  }[];
}

const RadioButtonInput: React.FC<Props> = ({
  setSelectedValue,
  name,
  options,
}) => {
  const [selected, setSelected] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(event.target.value);
    setSelectedValue(event.target.value);
  };

  return (
    <Wrapper>
      <CheckboxContainer>
        {options.map((option) => (
          <CheckboxLabel key={option.value}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={selected === option.value}
              onChange={handleChange}
            />
            {option.label}
          </CheckboxLabel>
        ))}
      </CheckboxContainer>
    </Wrapper>
  );
};

export default RadioButtonInput;
